import { createContext, useContext } from 'react';

import type { UseItinerary } from '@/handlers/useItinerary';

export const ItineraryContext = createContext<UseItinerary | undefined>(undefined);
export const ItineraryProvider = ItineraryContext.Provider;

export const useItineraryContext = () => {
  const context = useContext(ItineraryContext);
  if (context === undefined) {
    throw new Error('useItineraryContext must be used within a ItineraryProvider');
  }
  return context;
};
